import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ISpatStorageResource } from '../../../entities/farms.entities';
import MusselBulkSeedModal from './MusselBulkSeedModal';
import OysterBulkSeedModal from './OysterBulkSeedModal';
import { selectSpatStorages } from '../../../store/farms/farms.selector';
import { AreaClosedConfirmModal } from '../../CommonViews';

interface Props {
  data?: any;
  visible: boolean;
  batchID: number;
  onClose: (data?: any) => void;
  overConfirm?: (data?: any) => Promise<any>;
  className?: string;
}

const BulkSeedingModal = ({
  data,
  visible,
  batchID,
  onClose,
  overConfirm,
  className,
}: Props) => {
  const spats = useSelector(selectSpatStorages);
  const spatStorage = spats.find(x => x.id === batchID) as ISpatStorageResource;

  const [isConfirmed, setIsConfirmed] = useState(false);

  if (!isConfirmed) {
    return (
      <AreaClosedConfirmModal
        onCancel={() => onClose()}
        onConfirm={() => setIsConfirmed(true)}
      />
    );
  }
  return spatStorage.type === 'MUSSEL' ? (
    <MusselBulkSeedModal
      data={data}
      visible={visible}
      spatStorage={spatStorage}
      onClose={onClose}
      overConfirm={overConfirm}
      className={className}
    />
  ) : spatStorage.type === 'OYSTER' ? (
    <OysterBulkSeedModal
      data={data}
      visible={visible}
      spatStorage={spatStorage}
      onClose={onClose}
      overConfirm={overConfirm}
      className={className}
    />
  ) : (
    <></>
  );
};

export default BulkSeedingModal;
